import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-required-mark',
  templateUrl: './required-mark.component.html',
  styleUrls: ['./required-mark.component.css']
})
export class RequiredMarkComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
